module.exports = __webpack_public_path__ + "img/movie-azure.4427f291.jpg";